import { globalProperties } from '@/main.js'
import { fie } from '@/helpers/APIconnection'
import store from '@/store'
const axios = require('axios')
import fieValues from './fie-values'

// \.(date|ccc|regss|rzs|naf|region|document|country|ipf|nif|firstLastname|secondLastname|name|unenrollmentDate|recaida|contingencia|carencia|enrollmentDate)

const regex = {

    dni: /\d{8}[A-Z](?=\s*$)/,
    passport: /[A-Z]{2}\d{6}(?=\s*$)/,
    nie: /[XYZ]\d{7,8}[A-Z](?=\s*$)/,
}

const fieDataType = {

        alta: {
            summary: { text: 'Alta del trabajador/a', icon: 'icon-chevron-up text-xs', class: 'bg-second-100/10 text-second-100'},
            labels: [
                { key: 'enrollmentDate', title: 'Fecha Alta', icon: 'icon-chevron-up' },
                { key: 'unenrollmentDate', title: 'Fecha Baja IT', icon: 'icon-chevron-down' },
                { key: 'contingencia', title: 'Contingencia' },
                { key: 'carencia', title: 'Indicador Carencia' },
                { key: 'recaida', title: 'Indicador de recaída' }
            ]
        },

        baja: {
            summary: { text: 'Baja por incapacidad temporal', icon: 'icon-chevron-down text-xs', class: 'bg-[#b7094c0f] text-[#B7094C]' },
            labels: [
                { key: 'unenrollmentDate', title: 'Fecha Baja IT', icon: 'icon-chevron-down' },
                { key: 'contingencia', title: 'Contingencia' },
                { key: 'carencia', title: 'Indicador Carencia' },
                { key: 'recaida', title: 'Indicador de recaída' }
            ]
        },

        dip: {
            summary: { text: 'Baja por incapacidad permanente', icon: 'icon-less-rounded', class: 'bg-[#073b4c1c] text-[#073B4C]' },
            labels: [{ key: 'unenrollmentDate', title: 'Fecha Baja IT', icon: 'icon-chevron-down' }]
        },

        cit: {
            summary: { text: 'Continuación en situación de IT', icon: 'icon-short-text', class: 'bg-[#073b4c1c] text-[#073B4C]' },
            labels: [
                { key: 'enrollmentDate', title: 'Fecha Alta', icon: 'icon-chevron-up' },
                { key: 'unenrollmentDate', title: 'Fecha Baja IT', icon: 'icon-chevron-down' },
                { key: 'contingencia', title: 'Contingencia' },
                { key: 'carencia', title: 'Indicador Carencia' },
                { key: 'recaida', title: 'Indicador de recaída' }
            ]
        },

        dop: {
            summary: { text: 'Datos de otras prestaciones', icon: 'icon-form', class: 'bg-[#073b4c1c] text-[#073B4C]' },
            disabled: true
        },

        nac: {
            summary: { text: 'Datos sobre nacimientos', icon: 'icon-user', class: 'bg-second-100/10 text-second-100' },
            disabled: true,
            labels: [
                //Nacimiento
                { key: 'fechaNacimiento', title: 'Fecha Nacimiento', icon: 'icon-chevron-up' },
                //Nacimiento en otras prestaciones
                { key: 'fechaInicioPagoPrestacion', title: 'Fecha Inicio pago Prestación', icon: 'icon-chevron-up' },
                { key: 'fechaFinPagoPrestacion', title: 'Fecha Fin pago Prestación', icon: 'icon-chevron-down' } 
            
            ]
        },

        jub: {
            summary: { text: 'Jubilación', icon: 'icon-less-rounded', class: 'bg-[#073b4c1c] text-[#073B4C]'},
            disabled: true,
            labels: [
                { key: 'resolucionJub', title: 'Tipo de Resolución' },
                { key: 'fechaEfectosEconomicosJub', title: 'Fecha de Efectos Económicos' }
            ]
        }
    }

const savedCountries = {} // Saved countries from api

const StringToDate = function(string) {
            
    if (!string || string === '00000000') return

    if (typeof string === 'string' && (string.length === 8 || string.length === 12)) return new Date(`${string.slice(0, 4)}-${string.slice(4, 6)}-${string.slice(6, 8)}`)

    else {

        const date = new Date(string)
        
        if (!isNaN(date.getTime())) return date
    }
}

const GetCountryByCode = async function(code) { // eslint-disable-line

    try {

        if ( !code || isNaN(code) ) return

        if ( savedCountries[code] ) return savedCountries[code]

        const response = await axios('https://restcountries.com/v3/alpha/' + code).catch()
        
        if ( response?.status === 200 ) {

            const data = response.data[0]?.translations?.spa?.common

            if ( !savedCountries[code] ) { savedCountries[code] = data }
            
            return data
        }

    } catch (error) {} // eslint-disable-line
}

const NormalizeID = function (value, type) {

    if ( !value ) return

    if ( !type ) { type = IdentifyID(value) }

    value = value.toString()

    switch(type) {

        case 1: return value.match(regex.dni)?.[0]
        case 2: return value.match(regex.passport)?.[0]
        case 6: return value.match(regex.nie)?.[0]
    }

    return ''
}

const NormalizeCCC = (ccc = '') => {

    if (ccc.length === 11) return { ccc }

    const regex = /^(\d{4})(\d{11})$/
    const match = ccc.match(regex)

    const result = {}

    if (match) {

        result.regss = match[1]
        result.ccc = match[2]
    }

    return result
}

const IdentifyID = (value) => {

    if (regex.dni.test(value)) return 1
    else if (regex.nie.test(value)) return 6
    else if (regex.passport.test(value)) return 2
}

const sections = { // eslint-disable-line

    ETI: 'Etiquetas de proceso',
    EMP: 'Identificación de Empresa',
    RZS: 'Razón Social',
    TRA: 'Trabajador',
    AYN: 'Apellidos y Nombre',
    DAF: 'Datos de Afiliación',
    DIT: 'Datos de Incapacidad Temporal',
    IT2: 'Datos de Incapacidad Temporal 2',
    ITD: 'IT pago directo',
    CIT: 'Continuación situación en IT',
    DIP: 'Datos Incapacidad Permanente',
    JUB: 'Datos de Jubilación',
    DOP: 'Datos de otras Prestaciones',
    NAC: 'Datos sobre nacimientos',
    ETF: 'Etiquetas de proceso',
}

const equivalenceTable = {
    
    100: { section: 'ETI', label: 'Fecha de registro', regex: /fecha/, segment: [30, 12], type: Date },
    310: { section: 'EMP', ref: 'ccc', label: 'CCC', regex: /ccc/, segment: [4, 15], type: String },
    320: { section: 'EMP', ref: 'regss', label: 'Régimen de la Seguridad Social', type: String, regex: /reg/, segment: [4, 4], normalize: (value) => String(value).padStart(4, '0'), translate: 'T-2' },
    330: { section: 'EMP', label: 'Provincia', regex: /provincia/, segment: [8, 2], translate: 'provincias' },
    360: { section: 'EMP', label: 'Tipo de identificación', regex: /tipo/, segment: [19, 1], translate: 'T-3' },
    370: { section: 'EMP', label: 'País', regex: /pa[íi]s/, segment: [20, 3], /*translate: GetCountryByCode*/ },
    520: { section: 'EMP', label: 'Tipo empresario', regex: /tipo/, segment: [5, 1], translate: 'T-8' },
    530: { section: 'RZS', ref: 'rzs', label: 'Razón social', regex: /raz[óo]n/, segment: [6, 55] },
    610: { section: 'TRA', ref: 'naf', label: 'NAF', regex: /naf/, segment: [4, 12], type: String },
    620: { section: 'TRA', ref: 'region', label: 'Provincia', regex: /provincia/, segment: [4, 2], translate: 'provincias' },
    650: { section: 'TRA', ref: 'document', label: 'Tipo de Identificador', regex: /tipo/, segment: [16, 1], type: String, translate: 'T-11' },
    660: { section: 'TRA', ref: 'country', label: 'País', regex: /pa[íi]s/, segment: [17, 3], /*translate: GetCountryByCode*/ },
    670: { section: 'TRA', ref: 'nif', label: 'NIF', regex: /(ipf|nif)/, segment: [20, 14], type: String, normalize: (value) => NormalizeID(value) },
    820: { section: 'AYN', ref: 'firstLastname', label: 'Primer Apellido', regex: /primer/, segment: [4, 20] },
    830: { section: 'AYN', ref: 'secondLastname', label: 'Segundo Apellido', regex: /segundo/, segment: [24, 20] },
    840: { section: 'AYN', ref: 'name', label: 'Nombre', regex: /nombre/, segment: [44, 15] },
    910: { section: 'DAF', label: 'Fecha Inicio relación laboral', regex: /(ini.*)/, segment: [4, 8], type: Date },
    920: { section: 'DAF', label: 'Fecha Extinción relación laboral', regex: /(ext.*)/, segment: [12, 8], type: Date },
    1010: { section: 'DIT', label: 'Entidad responsable', regex: /entidad/, segment: [4, 3], type: String , normalize: (value) => String(value).padStart(3, '0'), translate: 'T-10' },
    1020: { section: 'DIT', ref: 'unenrollmentDate', label: 'Fecha baja IT', regex: /(fecha).*(baja)/, segment: [7, 8], type: Date },
    1030: { section: 'DIT', ref: 'recaida', label: 'Indicador de recaída', regex: /reca[íi]da/, segment: [15, 1], translate: '1030' },
    1040: { section: 'DIT', label: 'Fecha proceso inicial', regex: /(proceso).*(inicial)/, segment: [16, 8], type: Date },
    1050: { section: 'DIT', label: 'Fecha proceso anterior', regex: /(proceso).*(anterior)/, segment: [24, 8], type: Date },
    1060: { section: 'DIT', label: 'Días acumulados', regex: /d[íi]as/, segment: [32, 4], translate: (value) => Number.parseInt(value) + ' días' },
    1070: { section: 'DIT', label: 'Fecha proceso IT inexistente', regex: /(fecha).*(it).*(inexistente)/, segment: [36, 8], type: Date },
    1080: { section: 'DIT', label: 'Causa IT proceso inexistente', regex: /(causa).*(it).*(inexistente)/, segment: [44, 2], translate: 'T-92' },
    1090: { section: 'DIT', ref: 'contingencia', label: 'Contingencia', regex: /contingencia/, segment: [46, 1], translate: '1090' },
    1100: { section: 'DIT', ref: 'carencia', label: 'Indicador Carencia', regex: /carencia/, segment: [47, 1], translate: '1100' },
    1110: { section: 'DIT', label: 'Tipo de proceso', regex: /tipo/, segment: [48, 1], translate: '1110' },
    1120: { section: 'DIT', label: 'Duración estimada', regex: /duraci[óo]n/, segment: [49, 4], translate: (value) => Number.parseInt(value) + ' días' },
    1130: { section: 'DIT', label: 'Fecha fin Pago Delegado', regex: /(fecha).*(pago).*(delegado)/, segment: [53, 8], type: Date },
    1140: { section: 'DIT', label: 'Causa Fin Pago Delegado', regex: /(causa).*(pago).*(delegado)/, segment: [61, 2], translate: 'T-93' },
    1150: { section: 'DIT', ref: 'enrollmentDate', label: 'Fecha fin IT', regex: /(fecha).*(fin).*(it)/, segment: [63, 8], type: Date },
    1160: { section: 'DIT', label: 'Causa fin IT', regex: /(causa).*(fin).*(it)/, segment: [71, 2], translate: 'T-94' },
    1170: { section: 'DIT', label: 'Parte de baja anulado', regex: /parte/, segment: [73, 1] },
    1171: { section: 'DIT', label: 'Parte de alta anulado', regex: /parte/, segment: [74, 1] },
    1172: { section: 'DIT', label: 'Modalidad de pago', regex: /modalidad/, segment: [75, 1], translate: '1172' },
    1173: { section: 'DIT', label: 'Procesos con peculiaridades en pago y cotización', regex: /(procesos).*(peculiaridades)/, segment: [76, 2], translate: '1173' },
    1174: { section: 'DIT', label: 'Indicador de IT internacional', regex: /(internacional)/, segment: [78, 1], translate: '1174' },
    1185: { section: 'IT2', label: 'Fecha AT/EP', regex: /(fecha)/, segment: [4, 8], type: Date },
    1190: { section: 'IT2', label: 'Tipo de accidente', regex: /(tipo).*(accidente)/, segment: [12, 1], translate: '1190' },
    1191: { section: 'IT2', label: 'Tipo de asistencia', regex: /(tipo).*(asistencia)/, segment: [13, 1], translate: '1191' },
    1192: { section: 'IT2', label: 'Fecha siguiente revisión médica Parte de Baja', regex: /(fecha).*(revisi[óo]n).*(baja)/, segment: [14, 8], type: Date },
    1193: { section: 'IT2', label: 'Fecha Agotamiento 545 días de IT', regex: /(fecha).*(545)/, segment: [22, 8], type: Date },
    1194: { section: 'IT2', label: 'Fecha de envío PB, PC o PA al INSS', regex: /(fecha).*(env[íi]o)/, segment: [30, 8], type: Date },
    1195: { section: 'IT2', label: 'Base reguladora INSS', regex: /(base).*(reguladora)/, segment: [38, 6] },
    1198: { section: 'IT2', label: 'Código de resolución IT emitida por el INSS', regex: /c[óo]digo/, segment: [44, 2], translate: '1198' },
    1199: { section: 'IT2', label: 'Fecha de resolución IT emitida por el INSS', regex: /(fecha).*(resoluci[óo]n)/, segment: [46, 8], type: Date },
    1200: { section: 'IT2', label: 'Fecha notificación denegación IP al trabajador', regex: /(fecha).*(denegaci[óo]n)/, segment: [54, 8], type: Date },
    1310: { section: 'ITD', label: 'Fecha Inicio Pago directo', regex: /(fecha).*(inicio).*(pago).*(directo)/, segment: [4, 8], type: Date },
    1320: { section: 'ITD', label: 'Entidad Inicio Pago directo', regex: /(entidad).*(inicio).*(pago)/, segment: [12, 3], type: String , normalize: (value) => String(value).padStart(3, '0'), translate: 'T-10' },
    1330: { section: 'ITD', label: 'Entidad responsable actual', regex: /(entidad).*(actual)/, segment: [15, 3], type: String , normalize: (value) => String(value).padStart(3, '0'), translate: 'T-10' },
    1340: { section: 'ITD', label: 'Fecha Inicio Pago entidad responsable', regex: /(fecha).*(inicio).*(entidad)/, segment: [18, 8], type: Date },
    1350: { section: 'ITD', label: 'Fecha Fin pago directo', regex: /(fecha).*(fin).*(pago)/, segment: [26, 8], type: Date },
    1520: { section: 'CIT', label: 'Fecha del parte de confirmación', regex: /(fecha).*(confirmaci[óo]n)/, segment: [4, 8], type: Date },
    1530: { section: 'CIT', label: 'Número del parte de confirmación', regex: /(n.*).*(parte)/, segment: [12, 2] },
    1540: { section: 'CIT', label: 'Fecha de cumplimiento de 365 días', regex: /(fecha).*(365)/, segment: [14, 8], type: Date },
    1550: { section: 'CIT', label: 'Fecha siguiente revisión médica Parte Confirm.', regex: /(fecha).*(revisi[óo]n).*(parte)/, segment: [22, 8], type: Date },
    1610: { section: 'DIP', label: 'Fecha de baja IT', regex: /(fecha).*(baja).*(it)/, segment: [4, 8], type: Date },
    1620: { section: 'DIP', label: 'Fecha inicio expediente IP', regex: /(fecha).*(expediente)/, segment: [12, 8], type: Date },
    1630: { section: 'DIP', label: 'Entidad Responsable', regex: /entidad/, segment: [20, 3], type: String , normalize: (value) => String(value).padStart(3, '0'), translate: 'T-10' },
    1640: { section: 'DIP', label: 'Causa Inicio IP', regex: /(causa).*(inicio).*(ip)/, segment: [23, 2], translate: 'T-95' },
    1650: { section: 'DIP', label: 'Tipo de resolución', regex: /(tipo).*(resoluci[óo]n)/, segment: [25, 1], translate: '1650' },
    1660: { section: 'DIP', label: 'Fecha Hecho Causante IP', regex: /(fecha).*(hecho).*(ip)/, segment: [26, 8], type: Date },
    1670: { section: 'DIP', label: 'Origen Resolución IP', regex: /(origen).*(ip)/, segment: [34, 1], translate: '1670' },
    1680: { section: 'DIP', label: 'Fecha de Efectos Económicos IP', regex: /(fecha).*(efectos).*(ip)/, segment: [35, 8], type: Date },
    1690: { section: 'DIP', label: 'Fecha de Resolución IP', regex: /(fecha).*(resoluci[óo]n).*(ip)/, segment: [43, 8], type: Date },
    1700: { section: 'DIP', label: 'Tipo de IP', regex: /(tipo).*(ip)/, segment: [51, 1], translate: '1700' },
    1710: { section: 'DIP', label: 'Fecha Desde Demora', regex: /(fecha).*(desde).*(demora)/, segment: [52, 8], type: Date },
    1720: { section: 'DIP', label: 'Fecha Fin Demora', regex: /(fecha).*(fin).*(demora)/, segment: [60, 8], type: Date },
    1730: { section: 'DIP', label: 'Indicador de reserva de puesto de trabajo', regex: /(indicador).*(reserva)/, segment: [68, 1] },
    1740: { section: 'DIP', label: 'Fecha de Revisión', regex: /(fecha).*(revisi[óo]n)/, segment: [69, 8], type: Date },
    1805: { section: 'JUB', ref: 'resolucionJub', label: 'Tipo de resolución', regex: /resoluci[óo]n/, segment: [4, 1], translate: '1805' },
    1810: { section: 'JUB', label: 'Tipo de jubilación', regex: /jubilaci[óo]n/, segment: [5, 1], translate: '1810' },
    1820: { section: 'JUB', ref: 'fechaEfectosEconomicosJub', label: 'Fecha de Efectos Económicos', regex: /fecha/, segment: [6, 8], type: Date },
    1910: { section: 'DOP', label: 'Prestación', regex: /prestaci[óo]n/, segment: [4, 2], translate: '1910' },
    1920: { section: 'DOP', label: 'Motivo de solicitud', regex: /motivo/, segment: [6, 1], translate: 'T-89' },
    1930: { section: 'DOP', label: 'Entidad responsable', regex: /entidad/, segment: [7, 3], type: String , normalize: (value) => String(value).padStart(3, '0'), translate: 'T-10' },
    1940: { section: 'DOP', label: 'Fecha del Hecho causante', regex: /(fecha).*(hecho)/, segment: [10, 8], type: Date },
    1950: { section: 'DOP', ref: 'fechaInicioPagoPrestacion', label: 'Fecha Inicio pago Prestación', regex: /(fecha).*(inicio).*(pago)/, segment: [18, 8], type: Date },
    1960: { section: 'DOP', ref: 'fechaFinPagoPrestacion', label: 'Fecha Fin pago Prestación', regex: /(fecha).*(fin).*(pago)/, segment: [26, 8], type: Date },
    1970: { section: 'DOP', label: 'Causa Fin pago Prestación', regex: /(causa).*(fin).*(pago)/, segment: [34, 2], translate: 'T-96' },
    1990: { section: 'DOP', label: 'Porcentaje de parcialidad', regex: /porcentaje/, segment: [42, 5] },
    2020: { section: 'DOP', label: 'Ampliación del subsidio NYCM', regex: /ampliaci[óo]n/, segment: [47, 1] },
    2030: { section: 'DOP', label: 'Días de ampliación del subsidio NYCM', regex: /(d[íi]as).*(ampliaci[óo]n)/, segment: [48, 3] },
    2110: { section: 'NAC', ref: 'fechaNacimiento', label: 'Fecha de Nacimiento', regex: /fecha/, segment: [4, 8], type: Date }
}

const equivalenceTableBySection = Object.entries(equivalenceTable).reduce((acc, [key, value]) => { // eslint-disable-line

    const section = value?.section

    if (!section) return acc

    if (!acc[section]) acc[section] = {}
    acc[section][key] = value

    return acc

}, {})

// ===============| FIE Methods |===============

const GetSavedFIEs = async function(fielist, loading = {}) { // Get fies from ddbb

    if ( !fielist ) return

    let total = 0
    let loaded = 0

    loading.loadedPercentage = 0

    const response = await fie.get()

    if ( response?.status === 200 && response.data ) {

        total = response.data.items?.length ?? 0

        await Promise.all(response.data.items.map(async fie => {

            await DecodeFromDDBB(fie)

            loaded ++
            loading.loadedPercentage = Math.round(loaded / total * 100)

            const existingFIE = fielist?.find(f => f._id === fie._id)

            existingFIE ? Object.assign(existingFIE, fie) : fielist.push(fie)
        }))
    }
}

const SaveFIE = async function(data) { // Save single fie

    data.new = true

    const body = {

        entries: GetValuesFromEntries(data.entries),
        date: data.date
    }

    const response = await fie.create(body)

    if ( response?.status === 200 ) {

        data._id = response.data._id
        data.entries = data.entries.filter(entry => {

            entry.fieId = data._id
            return response.data.entries.some(e => e[310] === JustValue(entry[310]))
        })
    }

    return response?.status === 200
}

const DeleteFIE = async function(fieGroup) {

    if ( !fieGroup?._id ) return

    store.state.ui.promptModal = {

        title: 'Eliminar FIE',
        text: `Vas a eliminar el FIE de ${fieGroup.registryDate ?? globalProperties.$formatDate({ date: fieGroup.date ?? fieGroup.createAt, format: 'dd/mm/yyyy' })} con ${fieGroup.entries?.length} movimientos. Una vez eliminado no podrás recuperarlo.<br>Esto no afectará a los datos sincronizados en A3.`,
        footer: [
            { click: () => store.state.ui.promptModal = undefined, text: globalProperties.$st('general.cancel'), variant: 'outlined' },
            { click: async () => {
                
                fieGroup.removing = true

                const response = await fie.delete(fieGroup._id)

                if ( response?.status === 200 ) {

                    fieGroup.hidden = true
                }

                fieGroup.removing = false

                store.state.ui.promptModal = undefined

            }, text: globalProperties.$st('general.delete') }
        ]
    }
}

const GetValuesFromEntries = (entries) => {

    return entries.map(sch => Object.entries(sch).reduce((acc, [key, obj]) => {

        if (key in equivalenceTable || key === 'a3sync' || key === 'baseCotizacion') { acc[key] = JustValue(obj) }

        return acc

    }, {}))
}

const JustValue = (data) => { return typeof data === 'object' ? data.value ?? '' : data }

const GetValue = function(ref, value) { // Return and object with the expected ref value

    if ( !ref || !value ) return

    return (fieValues[ref]?.[value]) || '[[ Tabla no encontrada ]]'
}

const NormalizeValue = function(data) {

    if (!data) return

    if ( data.type === Date ) { return data.normalizedValue ? globalProperties.$formatDate({ date: data.normalizedValue, format: 'dd/mm/yyyy' }) : undefined }
    if ( typeof data === 'object' ) { return (data.normalizedValue || data.value)?.toString() }
}

const NormalizeEntry = async (entry, value) => {

    try {

        if ( entry.normalize ) { value = await entry.normalize(value) }
        
        const result = { label: entry.label, value, section: entry.section }

        if (entry.ref) { result.ref = entry.ref }
        
        if ( entry.type === Date && value ) {
            
            result.value = StringToDate(value)
            result.normalizedValue = globalProperties.$formatDate({ date: result.value, format: 'dd/mm/yyyy' })
        }

        else if ( value && !entry.type && !isNaN(value) ) { result.normalizedValue = result.value = parseInt(value) }
        
        if ( entry.translate ) {
            
            result.normalizedValue = entry.translate instanceof Function
                ? await entry.translate(result.value)
                : await GetValue(entry.translate, result.value) }

        return result

    } catch (error) {} // eslint-disable-line
}

// >> Normalize data to adjust some data and easily access the values ready to be displayed on the dashboard

const NormalizeFIEData = async (data, logs = null) => {

    data.fullname = `${JustValue(data[840])} ${JustValue(data[820])} ${JustValue(data[830])}`

    if (data[310]) {

        const normalizedCCC = NormalizeCCC(data[310].value)

        data[310].value = normalizedCCC.ccc

        if (!data[320]?.value) data[320] = await NormalizeEntry(equivalenceTable[320], normalizedCCC.regss)
    }

    if (!data[650]?.value) data[650] = await NormalizeEntry(equivalenceTable[650], IdentifyID(JustValue(data[670])))

    Object.values(data).forEach(item => { if (item?.ref) { data[item.ref] = item.normalizedValue ?? item.value } })

    if ( data[1610] ) data.type = 'dip' 
    else if ( data[1520] || data[1530] ) data.type = 'cit'
    else if ( data[2110] || JustValue(data[1910]) == "NC" ) data.type = 'nac'
    else if ( data[1910] ) data.type = "dop"
    else if ( data[1810] ) data.type = 'jub'

    else {

        data.isAlta = !!data[1150]
        data.isBaja = !data.isAlta

        const dateAlta = data[1150]?.value
        const dateBaja = data[1020]?.value

        if ( data.isAlta && dateBaja && dateAlta ) {

            data.duration = (dateAlta.getTime() - dateBaja.getTime()) / 86400000

            if ( data.duration <= 2 ) { data.shortDuration = true }
        }

        data.type = data.isAlta ? 'alta' : 'baja'
    }

    data.isCanceled = (data[1171] && data[1171].value === "S") || (data[1170] && data[1170].value === "S")

    //if logs find the last one
    if (logs) {

        let latestLog = null;

        for (const item of logs) {
            const inputUserLogs = item.logStreams?.['input-userLogStream'] || [];

            for (const log of inputUserLogs) {
                const isError = log.level === 'error';
                const containsDNI = typeof log.text === 'string' && log.text.includes(data.nif);
            
                if (isError && containsDNI) {
                    const logTime = new Date(log.timestamp);
                    if (!latestLog || logTime > new Date(latestLog.timestamp)) {
                        latestLog = log;
                    }
                }
            }
        }

        if (latestLog) { data.lastError = latestLog }
    }

    return data
}

const DecodeFromDDBB = async (fieData) => { // eslint-disable-line

    try {

        if (!fieData) return

        if (fieData.entries) {

            await Promise.all(fieData.entries.map(async (entry) => {

                entry.fieId = fieData._id

                await Promise.all(Object.entries(entry).map(async ([key, value]) => {
                    
                    if (key in equivalenceTable) {

                        entry[key] = await NormalizeEntry(equivalenceTable[key], value)
                    }
                }))

                await Promise.all(fieData.entries.map(async data => { await NormalizeFIEData(data, fieData.logs) }))
            }))

        } else if (fieData.content) {

            const processResponse = await ProcessRawTextFIE(fieData)

            if (processResponse) {
                
                Object.assign(fieData, processResponse)

                fieData.workers?.forEach(w => {

                    if (!w.nif) return

                    const match = fieData.entries.find(e => e.nif === w.nif)

                    if (!match) return

                    if ('a3sync' in w) match.a3sync = w.a3sync
                    if ('baseCotizacion' in w) match.baseCotizacion = w.baseCotizacion
                })

                const body = { // eslint-disable-line

                    entries: GetValuesFromEntries(fieData.entries),
                    _id: fieData._id
                }

                await fie.update(body)
            }
        }

        fieData.registryDate = GetRegistryDateRange(fieData)

    } catch (error) { globalProperties.$applog(`Error al decodificar FIE desde BBDD`, error) }
}

const GetRegistryDateRange = (fie) => {

    const dates = fie.entries.map(e => (JustValue(e[100]))?.getTime())

    const minDate = Math.min(...dates)
    const maxDate = Math.max(...dates)

    return minDate === maxDate ? globalProperties.$formatDate({ date: minDate, format: 'dd/mm/yyyy' }) : `${globalProperties.$formatDate({ date: minDate, format: 'dd/mm/yyyy' })} • ${globalProperties.$formatDate({ date: maxDate, format: 'dd/mm/yyyy' })}`
}

const ProcessNewFIEs = async function(rawList) {

    if ( !rawList?.length ) return

    const fielist = (await Promise.all(rawList.map(async raw => {

        let processResponse

        if (raw.excel) { processResponse = await ProcessSistemaRedExcel(raw) }
        else if (raw.txt || raw.content) { processResponse = await ProcessRawTextFIE(raw) }

        delete raw.data
        delete raw.content

        if (processResponse) { Object.assign(raw, processResponse) }

        if (raw.entries?.length) {

            raw.registryDate = GetRegistryDateRange(raw)

            if (await SaveFIE(raw)) { return raw }
            return 0
        }

    })))

    const result = fielist.reduce((acc, curr) => {

        if (curr) {

            acc.fies.push(curr)
            acc.success++

        } else if (curr === 0) acc.alreadysaved++
        else acc.error++

        return acc

    }, { fies: [], success: 0, error: 0, alreadysaved: 0 })

    let text = ''

    if (result.success) {

        text += result.success === 1 ? 'Se ha procesado un FIE.' : `Se han procesado ${result.success} FIEs.`
    }

    if (result.error) {

        if (text) text+= '<br>'
        text += text
            ? result.error === 1 ? 'Un archivo no se ha podido procesar.' : `No se han procesado ${result.error} archivos.`
            : result.error === 1 ? 'Este archivo no se ha podido procesar.' : 'No se ha procesado ningún archivo.'
    }

    if (result.alreadysaved) {

        if (text) text+= '<br>'
        text += text
            ? result.alreadysaved === 1 ? 'Un archivo se ha añadido anteriormente.' : `Se han añadido ${result.alreadysaved} archivos previamente.`
            : result.alreadysaved === 1 ? 'Este archivo ya se ha añadido anteriormente.' : 'Estos archivos ya se han añadido anteriormente.'
    }

    globalProperties.$createToastMessage({

        text,
        type: result.success ? 'success' : 'error',
        alive: 5000,
        fixed: true
    })

    return result.fies
}

const ProcessRawTextFIE = async function(fie) { // Format and decode SILTRA file

    if ( !fie?.content ) return

    const startAt = fie.content.indexOf('ETIFIE')
    const content = startAt > 0 ? fie.content.substring(startAt) : fie.content

    const lines = content.trim().replaceAll('\r', '').replaceAll(/\n+/g, '\n').split('\n')

    const data = []
    const generalData = {}
    const errorGrouping = []

    let currentCompany
    let currentWorker

    try {

        for (const line of lines) {

            const ref = line.slice(0, 3)

            if ( ref === 'ETI' ) {
                
                if ( !['FIE3', 'FIE4'].includes(line.slice(3, 7)) ) return
            }

            else if ( ref === 'EMP' ) currentCompany = {}
            else if ( ref === 'TRA' ) { currentWorker = { ...currentCompany, ...generalData }; data.push(currentWorker) }
            else if ( ref === 'ETF' ) break

            if ( ref in equivalenceTableBySection ) {

                try {

                    const sections = Object.entries(equivalenceTableBySection[ref])
                    let targetObject

                    if (ref === 'EMP' || ref === 'RZS') targetObject = currentCompany
                    else if (ref === 'ETI') targetObject = generalData
                    else targetObject = currentWorker

                    for (const section of sections) {

                        const [key, entry] = section
                        
                        if ( typeof entry !== 'object' ) { continue }

                        const start = entry.segment[0] - 1
                        const end = start + entry.segment[1]

                        let segment = line.slice(start, end).trim()

                        const normalizedEntry = await NormalizeEntry(entry, segment)

                        if ( !normalizedEntry?.value ) continue

                        targetObject[key] = normalizedEntry
                    }

                } catch(e) { errorGrouping.push(e) } // eslint-disable-line
            }
        }

        await Promise.all(data.map(async data => { await NormalizeFIEData(data) }))

    } catch (e) { errorGrouping.unshift(e) } // eslint-disable-line

    if (errorGrouping?.length) { globalProperties.$applog('Error al procesar un FIE [texto]', errorGrouping) }

    const processedFIE = Object.assign(fie, { entries: data, date: generalData[100]?.value })

    return processedFIE
}

const ProcessSistemaRedExcel = async (raw) => {

    try {

        const groupHeaders = raw.data[0]
        let currentGroupSections = Object.entries(equivalenceTableBySection['ETI'])

        const schemas = raw.data[1].map((header, index) => {

            const group = groupHeaders[index]

            if ( group ) { currentGroupSections = Object.entries(equivalenceTableBySection[group.slice(0, 3)]) }

            const normalizedHeader = header?.replace(/[.-]/g, '').toLowerCase()
            return currentGroupSections.find(eq => eq[1].regex?.test(normalizedHeader)) ?? []
        })

        const entries = await Promise.all(raw.data.slice(2).map(async row => {

            const entry = {}

            await Promise.all(row.map(async (item, index) => {

                if (!item) return
                
                const [key, schema] = schemas[index]

                if (!schema) return

                const normalizedEntry = await NormalizeEntry(schema, item)

                if (!normalizedEntry?.value) return

                entry[key] = normalizedEntry
            }))

            await NormalizeFIEData(entry)

            return entry
        }))

        const dates = entries.map(e => (JustValue(e[100]))?.getTime())

        const registryDate = dates.length ? new Date(Math.min(...dates)) : new Date()

        return { entries, date: registryDate }

    } catch (error) { globalProperties.$applog(`Error al procesar un FIE [excel]`, error) }
}

const GetIncidencia = function(fie, shortDurationBaja) {

    if (fie.enrollmentDate && !shortDurationBaja) { return "7" }

    if (fie[1173]) {

        const incidencias = { 1: "45", 2: "46", 4: "48" }
        return incidencias[fie[1173].value];
    }

    const incidencias = JustValue(fie[1030]) === "S" ?  { 1: "5", 2: "5", 3: "6", 4: "6", 5: "6" } : { 1: "2", 2: "2", 3: "3", 4: "3", 5: "3" }
    return incidencias[JustValue(fie[1090])];
}

const FormatFIEDataForA3 = function(fie) {

    const ccc = JustValue(fie[310])

    const formatted = {

        fieId: fie.fieId,
        dniEmpleado: JustValue(fie[670]),
        nombreEmpresa: JustValue(fie[530]),
        fechaFormateada: fie.enrollmentDate || fie.unenrollmentDate,
        incidencia: GetIncidencia(fie),
        carencia: JustValue(fie[1100]) === "S",
        contingencia: JustValue(fie[1090]),
        ccc,
        formatedccc: ccc.slice(0, 2) + '/' + ccc.slice(2, -2) + '-' + ccc.slice(-2),
        diasAcumulados: JustValue(fie[1030]) === "S" ? JustValue(fie[1060]) : 0,
        fechaBajaBajaDuracion: !fie.isCanceled && fie.enrollmentDate ? fie.unenrollmentDate : '',
        incidenciaBajaBajaDuracion: !fie.isCanceled && fie.enrollmentDate ? GetIncidencia(fie, true) : '',
        canceled: fie.isCanceled
    }

    formatted.date = formatted.fechaFormateada
    formatted.incidenceCode = formatted.incidencia
    formatted.workerDNI = formatted.dniEmpleado

    return formatted
}

const SyncA3 = async (data) => {

    const flowData = { ...data, flowId: '67517f8e806315ef9daf439d', flowInputs: { 'input-dataTable': { value: data.flowInputs?.fies, type: "LIST" } } }

    const fieIds = data.flowInputs?.fies.reduce((acc, current) => { if ( !acc.includes(current.fieId) ) { acc.push(current.fieId) } return acc }, [])
    
    if ( fieIds?.length ) flowData.fieIds = fieIds

    return await globalProperties.$desktopAppComunication("RunFieRobot", flowData)
}

const GetFieFromSILTRA = async (data, options = {}) => {

    // ======| Check date input

    if ( !(Array.isArray(data.flowInputs?.date) && data.flowInputs.date.length) ) {

        const response = await fie.get('?select=date')

        const today = new Date().setHours(0, 0, 0, 0)

        if ( response?.status === 200 && response.data?.items?.some(i => i.date) ) {
            
            const mostRecentDate = Math.max(...response.data.items.map(item => item.date ? new Date(item.date).getTime() : 0))

            data.flowInputs.date = [mostRecentDate]

            if ( today !== mostRecentDate ) data.flowInputs.date.push(today)

        } else { data.flowInputs.date = [today] }
    }

    const flowData = { ...data, flowInputs: { "input-certificate": data.flowInputs?.certificates, "input-msRange": data.flowInputs?.date } }

    const rawFies = await globalProperties.$desktopAppComunication("GetFieFromSiltra", flowData)

    if ( !rawFies?.length ) {

        if (options.infoModalsEnabled) {

            const from = data.flowInputs?.date?.[0] ? globalProperties.$formatDate({ date: data.flowInputs?.date[0], format: 'dd/mm/yyyy' }) : undefined
            const to = data.flowInputs?.date?.[1] ? globalProperties.$formatDate({ date: data.flowInputs?.date[1], format: 'dd/mm/yyyy' }) : undefined

            globalProperties.$createToastMessage({

                title: 'No hemos encontrado ningún FIE en SILTRA',
                text: !to ? `Sin resultados en el dia ${from}` : `Sin resultados entre el ${from} y el ${to}`,
                type: 'error',
                alive: 5000,
                fixed: true
            })
        }

        return
    }

    return await ProcessNewFIEs(rawFies)
}

const SyncSILTRAA3 = async (data, options = {}) => {

    let fies = await GetFieFromSILTRA(data, options)

    if ( !fies?.length ) return

    fies = fies.flatMap(f => f.entries ?? [])

    if (!fies?.length) return

    const normalizedFIEsForA3 = fies.filter(fie => !fieDataType[fie.type]?.disabled).map(fie => FormatFIEDataForA3(fie))

    const syncResponse = await SyncA3({...data, flowInputs: { fies: normalizedFIEsForA3 }})

    if ( syncResponse, options.response ) options.response({ fies, log: syncResponse })

    return syncResponse
}

export default {

    fieDataType,
    equivalenceTable,
    sections,
    NormalizeValue,
    ProcessRawTextFIE,
    ProcessNewFIEs,
    GetSavedFIEs,
    DeleteFIE,
    FormatFIEDataForA3,
    SyncA3,
    GetFieFromSILTRA,
    SyncSILTRAA3
}